/* istanbul ignore file */

import Vue from "vue";
import ReadMore from "../components/read-more/ReadMore";
import StoreVendorsMap from "../components/vendors-map/StoreVendorsMap";
import store from "../store";
import { mapActions } from "vuex";

const vueEl = "[data-vue-view='vendors-index']";

document.ready.then(() => {
  if (document.querySelector(vueEl)) {
    new Vue({
      el: vueEl,
      store,
      name: "VendorsIndex",
      components: {
        "read-more": ReadMore,
        "store-vendors-map": StoreVendorsMap,
      },
      mounted() {
        window._lytics_.attachEventListeners(this.$el);
      },
      methods: {
        ...mapActions({
          setVendorsMapVisibility: "vendorsIndex/setVendorsMapVisibility",
        }),
        showVendorMap() {
          this.setVendorsMapVisibility(true);
        },
      },
    });
  }
});
